import { render, staticRenderFns } from "./CallCentreEleenaData.vue?vue&type=template&id=c285333a&scoped=true"
import script from "./CallCentreEleenaData.vue?vue&type=script&lang=ts"
export * from "./CallCentreEleenaData.vue?vue&type=script&lang=ts"
import style0 from "./CallCentreEleenaData.vue?vue&type=style&index=0&id=c285333a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c285333a",
  null
  
)

export default component.exports